<template>
  <div>
    <Head title="Dettagli Prenotazione" />
    <div class="mb-8">
      <Link class="text-indigo-600 hover:text-indigo-800" href="/account">
        ← Torna alle prenotazioni
      </Link>
    </div>

    <h1 class="mb-8 text-3xl font-bold">Prenotazione #{{ booking.id }}</h1>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <!-- Booking Details -->
      <div class="bg-white rounded-md shadow overflow-hidden">
        <div class="p-6">
          <h2 class="text-xl font-semibold mb-4">Dettagli</h2>
          <div class="space-y-3">
            <div class="flex justify-between">
              <span class="text-gray-600">Nome:</span>
              <span class="font-medium">{{ booking.first_name }} {{ booking.last_name }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-600">Email:</span>
              <span class="font-medium">{{ booking.email }}</span>
            </div>
            <div v-if="booking.phone" class="flex justify-between">
              <span class="text-gray-600">Telefono:</span>
              <span class="font-medium">{{ booking.phone }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-600">Data Visita:</span>
              <span class="font-medium">{{ formatDate(booking.pass_date) }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-600">Adulti:</span>
              <span class="font-medium">{{ booking.qty_adults }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-600">Bambini:</span>
              <span class="font-medium">{{ booking.qty_kids }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-600">Totale Pagato:</span>
              <span class="font-medium text-green-600">€{{ booking.paid_amount }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-600">Stato:</span>
              <span class="px-2 py-1 text-xs rounded" :class="getStatusClass(booking.payment_status)">
                {{ booking.payment_status_label }}
              </span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-600">Validato:</span>
              <span v-if="booking.validated" class="text-green-600 font-medium">Sì</span>
              <span v-else class="text-gray-400">No</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Booking Info -->
      <div class="bg-white rounded-md shadow overflow-hidden">
        <div class="p-6">
          <h2 class="text-xl font-semibold mb-4">Informazioni Biglietto</h2>
          <p class="text-sm text-gray-600 mb-4">
            Mostra questa prenotazione all'ingresso per la convalida.
          </p>
          <div class="bg-gray-50 rounded-lg p-6 text-center">
            <div class="text-4xl font-bold text-indigo-600 mb-2">
              #{{ booking.id }}
            </div>
            <div class="text-sm text-gray-600 mb-4">
              Codice Prenotazione
            </div>
            <div v-if="booking.qr_code" class="mt-4 flex justify-center">
              <img :src="booking.qr_code" alt="QR Code Prenotazione" class="w-48 h-48 border-2 border-gray-300 rounded-lg" />
            </div>
<!--            <div class="mt-4 text-xs text-gray-500">-->
<!--              Token: {{ booking.token }}-->
<!--            </div>-->
          </div>
          <div class="mt-4 p-4 bg-blue-50 rounded-lg">
            <p class="text-sm text-blue-800">
              💡 Scansiona il codice QR all'ingresso o presenta il numero di prenotazione insieme a un documento d'identità
            </p>
          </div>
        </div>
      </div>

      <!-- Station Details -->
      <div v-if="booking.stations && booking.stations.length > 0" class="bg-white rounded-md shadow overflow-hidden lg:col-span-2">
        <div class="p-6">
          <h2 class="text-xl font-semibold mb-4">Ombrelloni</h2>
          <div class="space-y-3">
            <div
              v-for="(station, index) in booking.stations"
              :key="index"
              class="border-b pb-3 last:border-b-0"
            >
              <div class="flex justify-between items-center">
                <div>
                  <span class="font-medium">Ombrellone {{ station.id }}</span>
                  <span class="text-gray-600 text-sm ml-2">
                    ({{ station.sunbedCount }} Lettini)
                  </span>
                </div>
                <div class="text-sm text-gray-600">
                  <div v-if="station.extraSunbedCount">Extra lettini: {{ station.extraSunbedCount }}</div>
                  <div v-if="station.extraAdultCount">Extra adulti: {{ station.extraAdultCount }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountLayout from "@/Pages/Account/Shared/AccountLayout.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";
import moment from "moment";
import "moment/locale/it"; // Import Italian locale for moment.js

export default {
  components: {
    Head,
    Link,
  },
  layout: AccountLayout,
  props: {
    booking: Object,
  },
  methods: {
    formatDate(date) {
      return moment(date).locale("it").format("DD MMMM YYYY");
    },
    getStatusClass(status) {
      if (status === 1) {
        return "bg-green-100 text-green-800";
      }
      return "bg-gray-100 text-gray-800";
    },
  },
};
</script>
